import { render } from "./RedirectPage.vue?vue&type=template&id=35afe044&scoped=true"
import script from "./RedirectPage.vue?vue&type=script&lang=js"
export * from "./RedirectPage.vue?vue&type=script&lang=js"

import "./RedirectPage.vue?vue&type=style&index=0&id=35afe044&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35afe044"]])

export default __exports__